$(function() {
    // collapse filters
    var searchExpand = $('.search__card-header');

    searchExpand.click(function() {
        $(this).closest('.search__card').toggleClass('active');
    });
})